namespace $.$$ {

	export class $shm_hitalama_textbook_text extends $.$shm_hitalama_textbook_text {

		@ $mol_mem_key
		override header_arg( index: number ) {
			const title = this.block_text( index ).trim()
			const count = this.flow_tokens().slice( 0, index + 1 )
				.filter( token => token.name === 'header' && token.chunks[2].trim() === title ).length
			return { [ this.param() ]: count > 1 ? `${ title } [${ count }]` : title }
		}

	}
	
	export class $shm_hitalama_textbook_text_header extends $.$shm_hitalama_textbook_text_header {
		
		current() {
			const arg = this.arg()
			const keys = Object.keys( arg )
				.filter( key => arg[ key ] != null )
			
			if( keys.length === 0 ) return false
			
			return keys.every( key => this.$.$mol_state_arg.value( key ) === arg[ key ] )
		}
		
		attr() {
			return {
				... super.attr(),
				shm_hitalama_textbook_text_header_current: this.current() || null,
			}
		}
		
	}
	
}
